// node-modules
import ScrollMagic from 'scrollmagic';

// constants
import { SELECTORS } from '@/scripts/constants';

// other
import { controller } from '@/components/_scrollmagic';

// assets
import './simple-revealer.scss';

export default function reveal(container = document) {
  const scenes = [];
  container.querySelectorAll('[data-role*="simple-reveal"]')
    .forEach((revealContainer) => {
      const $overlay = $('<div class="reveal__overlay"/>');
      $(revealContainer)
        .addClass('reveal')
        .append($overlay)
        .find('[data-role*="reveal-target"]')
        .addClass('reveal__target');
      scenes.push(new ScrollMagic.Scene({
        triggerElement: revealContainer,
        triggerHook: 'onEnter',
        offset: 150,
        reverse: false,
      })
        .on('start', () => {
          $(revealContainer).addClass(SELECTORS.loaded);
        })
        // .addIndicators({name: 'simple-revealer'})
        .addTo(controller));
    });
  return scenes;
}




// WEBPACK FOOTER //
// ./components/_scrollmagic/scenes/simple-revealer/simple-revealer.js